"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactModal = require("react-modal");
const icons_1 = require("@dialogexe/cw-asset-provider/icons");
class Cover extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            videoOpen: false
        };
        this.openVideo = () => {
            this.setState({
                videoOpen: true
            });
        };
        this.closeVideo = () => {
            this.setState({
                videoOpen: false
            });
        };
    }
    render() {
        const { video, image, title } = this.props;
        if (!image && !title) {
            return (React.createElement("div", null));
        }
        return (React.createElement("div", { className: `Cover ${image ? '' : 'has-no-image'}` },
            React.createElement("div", { className: `image ${image ? '' : 'is-blank'}`, style: { backgroundImage: image ? `url("${image}")` : null } },
                React.createElement("div", { className: "container" },
                    video && video.key && (React.createElement("div", { className: "video-button" },
                        React.createElement("button", { className: "icon-button is-huge", onClick: this.openVideo },
                            React.createElement("img", { src: icons_1.playIcon, alt: "" })))),
                    title && (React.createElement("h1", { className: "title" }, title))),
                video && video.key && (React.createElement(ReactModal, { isOpen: this.state.videoOpen, ariaHideApp: false, className: "modal", overlayClassName: "modal-overlay", portalClassName: "modal-portal", shouldCloseOnEsc: true, shouldCloseOnOverlayClick: true, onRequestClose: this.closeVideo },
                    React.createElement("div", { className: "embedded-player" },
                        React.createElement("iframe", { src: this.getVideoUrl(), frameBorder: "0" })))))));
    }
    getVideoUrl() {
        const { provider, key } = this.props.video;
        switch (provider) {
            case 'youtube':
                return `https://youtube.com/embed/${key}?autoplay=1&fs=1`;
            case 'vimeo':
                return `https://player.vimeo.com/video/${key}`;
            default:
                throw new Error(`Video provider "${provider}" is not supported.`);
        }
    }
}
exports.Cover = Cover;
exports.default = Cover;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-cover/Cover.tsx